/* @flow */


import VanillaToasts from 'vanillatoasts';
import getInputPorId from './get-input-por-id';

import MENSAGENS from '../mensagens';

const mensagemTipoArquivoInvalido = () => {
    VanillaToasts.create({
        type: 'warning',
        title: MENSAGENS.EMPRESA.TIPO_ARQUIVO_INVALIDO.TITULO,
        text: MENSAGENS.EMPRESA.TIPO_ARQUIVO_INVALIDO.TEXTO,
        timeout: 5000,
    });
};

const getFileImagemInput = (inputId: string): File | null => {
    const input = getInputPorId(inputId);
    const file = input.files[0];
    if (!file) {
        return null;
    }

    if (!/image\/[a-z]+/.test(input.files[0].type)) {
        mensagemTipoArquivoInvalido();
        return null;
    }

    return file;
};

export default getFileImagemInput;
